<template>
  <div>
    <!-- Carousel Start -->
    <div class="container-fluid p-0 wow fadeIn" data-wow-delay="0.1s">
      <div class="owl-carousel header-carousel py-5">
        <div class="container py-5">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="carousel-text">
                <h1 class="display-1 text-uppercase mb-3">Safari Strives</h1>
                <p class="fs-5 mb-5">Every Person, Every Opportunity</p>
                <div class="d-flex">
                  <a class="btn btn-primary py-3 px-4 me-3" href="/services">Get Involved</a>
                  <a class="btn btn-secondary py-3 px-4" href="/about">Learn More</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel-img">
                <img class="w-100" src="/img/carousel-1.jpg" alt="Safari Strives - Every Person, Every Opportunity">
              </div>
            </div>
          </div>
        </div>
        <div class="container py-5">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="carousel-text">
                <h1 class="display-1 text-uppercase mb-3">Safari Strives</h1>
                <p class="fs-5 mb-5">Every Person, Every Opportunity</p>
                <div class="d-flex mt-4">
                  <a class="btn btn-primary py-3 px-4 me-3" href="/services">Our Work</a>
                  <a class="btn btn-secondary py-3 px-4" href="/contact">Contact Us</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel-img">
                <img class="w-100" src="/img/carousel-2.jpg" alt="Safari Strives - Every Person, Every Opportunity">
              </div>
            </div>
          </div>
        </div>
        <div class="container py-5">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="carousel-text">
                <h1 class="display-1 text-uppercase mb-3">Safari Strives</h1>
                <p class="fs-5 mb-5">Every Person, Every Opportunity</p>
                <div class="d-flex mt-4">
                  <a class="btn btn-primary py-3 px-4 me-3" href="/services">Learn More</a>
                  <a class="btn btn-secondary py-3 px-4" href="/contact">Get Started</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel-img">
                <img class="w-100" src="/img/carousel-3.jpg" alt="Safari Strives - Every Person, Every Opportunity">
              </div>
            </div>
          </div>
        </div>
        <div class="container py-5">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="carousel-text">
                <h1 class="display-1 text-uppercase mb-3">Safari Strives</h1>
                <p class="fs-5 mb-5">Every Person, Every Opportunity</p>
                <div class="d-flex mt-4">
                  <a class="btn btn-primary py-3 px-4 me-3" href="/services">Our Services</a>
                  <a class="btn btn-secondary py-3 px-4" href="/about">About Us</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel-img">
                <img class="w-100" src="/img/carousel-4.jpg" alt="Safari Strives - Every Person, Every Opportunity">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Carousel End -->

    <!-- Video Start -->
    <!-- Commented out - may be used later -->
    <!--
    <div class="container-fluid bg-primary mb-5 wow fadeIn" data-wow-delay="0.1s">
      <div class="container">
        <div class="row g-0">
          <div class="col-lg-11">
            <div class="h-100 py-5 d-flex align-items-center">
              <button
                type="button"
                class="btn-play"
                data-bs-toggle="modal"
                data-src="https://www.youtube.com/embed/Aqh1WMs8wb0"
                data-bs-target="#videoModal"
              >
                <span></span>
              </button>
              <h3 class="ms-5 mb-0">Together, we can build a world where everyone has the chance to thrive.</h3>
            </div>
          </div>
          <div class="d-none d-lg-block col-lg-1">
            <div class="h-100 w-100 bg-secondary d-flex align-items-center justify-content-center">
              <span class="text-white" style="transform: rotate(-90deg);">Scroll Down</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- Video End -->

    <!-- About Start -->
    <!-- Commented out - testing layout -->
    <!--
    <div class="container-fluid py-5">
      <div class="container">
        <div class="row g-5 align-items-center">
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.2s">
            <div class="about-img">
              <img class="img-fluid w-100" src="/img/about.png" alt="Safari Strives - About Us">
            </div>
          </div>
          <div class="col-lg-6">
            <p class="section-title bg-white text-start text-primary pe-3">About Us</p>
            <h1 class="display-6 mb-4 wow fadeIn" data-wow-delay="0.2s">Every Person, Every Opportunity</h1>
            <p class="mb-4 wow fadeIn" data-wow-delay="0.3s">Safari Strives is a non-profit organization that builds economic independence through a single, self-funding ecosystem. We do not rely on donations.</p>
            <div class="row g-4 pt-2">
              <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                <div class="h-100">
                  <h3>Our Vision</h3>
                  <p>To create a world where economic independence empowers individuals and communities to make informed choices that lead to sustainable development and a better quality of life.</p>
                </div>
              </div>
              <div class="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                <div class="h-100">
                  <h3>Our Mission</h3>
                  <p>To nurture the development of social enterprises that drive long-term economic revitalization, laying the foundation for thriving communities and fostering a sustainable improvement in social and living standards.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- About End -->

    <!-- Features Start -->
    <div class="container-fluid py-5">
      <div class="container">
        <div class="row g-5 align-items-center">
          <div class="col-lg-6">
            <div class="row g-4">
              <div class="col-6 wow fadeIn" data-wow-delay="0.4s">
                <div class="text-center">
                  <i class="fa fa-sitemap fa-3x text-primary mb-3"></i>
                  <h4>Ecosystem</h4>
                  <p class="mb-0">Self-funding model</p>
                </div>
              </div>
              <div class="col-6 wow fadeIn" data-wow-delay="0.5s">
                <div class="text-center">
                  <i class="fa fa-chart-line fa-3x text-primary mb-3"></i>
                  <h4>Profit</h4>
                  <p class="mb-0">Sustainable business</p>
                </div>
              </div>
              <div class="col-6 wow fadeIn" data-wow-delay="0.6s">
                <div class="text-center">
                  <i class="fa fa-hand-holding-usd fa-3x text-primary mb-3"></i>
                  <h4>Microfinance</h4>
                  <p class="mb-0">Zero percent, fast</p>
                </div>
              </div>
              <div class="col-6 wow fadeIn" data-wow-delay="0.7s">
                <div class="text-center">
                  <i class="fa fa-heart fa-3x text-primary mb-3"></i>
                  <h4>Dignity</h4>
                  <p class="mb-0">Dignity-centered</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="wow fadeIn" data-wow-delay="0.2s">
              <h1 class="display-6 mb-4">Why Safari Strives is Different</h1>
              <p class="mb-4">At Safari Strives we are reimagining development in Africa, not through aid, but through enterprise. We believe poverty is solved by prosperity, and prosperity is built by entrepreneurs.</p>
            </div>
            <div class="row g-4">
              <div class="col-12 wow fadeIn" data-wow-delay="0.4s">
                <h3 class="text-primary mb-3">Vision</h3>
                <p class="mb-0">To create a world where economic independence empowers individuals and communities to make informed choices that lead to sustainable development and a better quality of life.</p>
              </div>
              <div class="col-12 wow fadeIn" data-wow-delay="0.5s">
                <h3 class="text-primary mb-3">Mission</h3>
                <p class="mb-0">To nurture the development of social enterprises that drive long-term economic revitalization, laying the foundation for thriving communities and fostering a sustainable improvement in social and living standards.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Features End -->

    <!-- Our Recent Project Start -->
    <div class="container-fluid py-5" style="background: url(/img/bg.jpg) center center no-repeat; background-size: cover;">
      <div class="container">
        <div class="text-center mx-auto wow fadeIn" data-wow-delay="0.1s" style="max-width: 500px;">
          <p class="section-title bg-white text-center text-primary px-3">Our Recent Project</p>
          <h1 class="display-6 mb-4">Stories From The Field</h1>
        </div>
        <div class="row g-4">
          <div
            v-for="(project) in workProjects"
            :key="project.title"
            class="col-md-6 col-lg-4 wow fadeIn"
            :data-wow-delay="project.delay"
          >
            <div class="donation-item d-flex h-100 p-4">
              <div class="donation-detail">
                <div class="position-relative mb-4" style="padding-bottom: 75%; height: 0; overflow: hidden; background: #000;">
                  <video
                    class="position-absolute top-0 left-0 w-100 h-100"
                    :src="project.videoSrc"
                    controls
                    style="object-fit: cover;"
                  >
                    Your browser does not support the video tag.
                  </video>
                  <span class="btn btn-sm btn-secondary px-3 position-absolute top-0 end-0" style="z-index: 10; margin: 10px;">{{ project.label }}</span>
                </div>
                <h3 class="mb-3">{{ project.title }}</h3>
                <p class="mb-3">{{ project.description }}</p>
                <a href="/services" class="btn btn-primary w-100 py-3">
                  <i class="fa fa-arrow-right me-2"></i>Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Our Recent Project End -->
    <!-- Team Start -->
    <!-- Commented out - may be used later -->
    <!--
    <div class="container-fluid py-5">
      <div class="container">
        <div class="text-center mx-auto wow fadeIn" data-wow-delay="0.1s" style="max-width: 500px;">
          <p class="section-title bg-white text-center text-primary px-3">Our Team</p>
          <h1 class="display-6 mb-4">Meet Our Dedicated Team Members</h1>
        </div>
        <div class="row g-4">
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.1s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-1.jpg" alt="Elie Imani">
                <h3>Elie Imani</h3>
                <span>Executive Director & Co-Founder</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.3s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-2.jpg" alt="Martin Sheehan">
                <h3>Martin Sheehan</h3>
                <span>Co-Founder</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.5s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-3.jpg" alt="Carolina Alfaro">
                <h3>Carolina Alfaro</h3>
                <span>Women Program Director</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.7s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-4.jpg" alt="Ayano Shimizu">
                <h3>Ayano Shimizu</h3>
                <span>Graphic Designer</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.9s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-5.jpg" alt="Aharf Kamwithi">
                <h3>Aharf Kamwithi</h3>
                <span>Program Director</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="1.1s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-6.jpg" alt="Hakizimana Joel">
                <h3>Hakizimana Joel</h3>
                <span>Program Director</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="1.3s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-7.jpg" alt="Josue Manishimwe">
                <h3>Josue Manishimwe</h3>
                <span>Program Manager</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="1.5s">
            <div class="team-item d-flex h-100 p-4">
              <div class="team-detail pe-4">
                <img class="img-fluid mb-4" src="/img/team-8.jpg" alt="Emmanuel">
                <h3>Emmanuel</h3>
                <span>Innovation Director</span>
              </div>
              <div class="team-social bg-light d-flex flex-column justify-content-center flex-shrink-0 p-4">
                <a class="btn btn-square btn-primary my-2" href="https://www.instagram.com/safaristrives" target="_blank"><i class="fab fa-instagram"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.youtube.com/@safaristrives" target="_blank"><i class="fab fa-youtube"></i></a>
                <a class="btn btn-square btn-primary my-2" href="https://www.linkedin.com/company/safaristrives" target="_blank"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- Team End -->

    <!-- Testimonial Start -->
    <div class="container-fluid py-5">
      <div class="container">
        <div class="row g-5">
          <div class="col-md-12 col-lg-4 col-xl-3 wow fadeIn" data-wow-delay="0.1s">
            <div class="testimonial-title">
              <h1 class="display-6 mb-4">What People Say About Our Activities.</h1>
              <p class="fs-5 mb-0">We work to bring smiles, hope, and a brighter future to those in need.</p>
            </div>
          </div>
          <div class="col-md-12 col-lg-8 col-xl-9">
            <div class="owl-carousel testimonial-carousel wow fadeIn" data-wow-delay="0.3s">
              <div class="testimonial-item">
                <div class="row g-5 align-items-center">
                  <div class="col-md-6">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="/img/testimonial-1.jpg" alt="Dr. Anne Bradley - Former CIA Economist">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="testimonial-text pb-5 pb-md-0">
                      <div class="mb-2">
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                      </div>
                      <p class="fs-5">Economic growth requires institutions that recognize people have dignity, that people are equal, and that work is the only way to lift people up permanently from poverty.</p>
                      <div class="d-flex align-items-center">
                        <div class="btn-lg-square bg-light text-secondary flex-shrink-0">
                          <i class="fa fa-quote-right fa-2x"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="mb-0">Dr. Anne Bradley</h5>
                          <span>Former CIA Economist</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="testimonial-item">
                <div class="row g-5 align-items-center">
                  <div class="col-md-6">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="/img/team-1.jpg" alt="Elia Imani - Founder">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="testimonial-text pb-5 pb-md-0">
                      <div class="mb-2">
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                      </div>
                      <p class="fs-5">I have seen many organizations lead with good intentions while neglecting what is practical. At Safari Strives, we do both, the right thing and the workable thing, for our sisters.</p>
                      <div class="d-flex align-items-center">
                        <div class="btn-lg-square bg-light text-secondary flex-shrink-0">
                          <i class="fa fa-quote-right fa-2x"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="mb-0">Elia Imani</h5>
                          <span>Founder</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="testimonial-item">
                <div class="row g-5 align-items-center">
                  <div class="col-md-6">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="/img/testimonial-3.jpg" alt="Mbabazi Ange - Employee">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="testimonial-text pb-5 pb-md-0">
                      <div class="mb-2">
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                        <i class="fa fa-star text-primary"></i>
                      </div>
                      <p class="fs-5">Before joining Safari Strives, I didn't have much hope for what I could do. But here, I learned skills that made me believe in myself again. Now I see that with hard work and the right support, my dreams can actually come true.</p>
                      <div class="d-flex align-items-center">
                        <div class="btn-lg-square bg-light text-secondary flex-shrink-0">
                          <i class="fa fa-quote-right fa-2x"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="mb-0">Mbabazi Ange</h5>
                          <span>Employee</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Testimonial End -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'

export default defineComponent({
  name: 'HomeView',
  setup () {
    // Our Work section videos - replace with your uploaded video file paths
    const workProjects = ref([
      {
        videoSrc: '/videos/carolina.mp4', // Carolina Alfaro recent project video
        label: 'Carolina Alfaro',
        title: 'Microloan Project: Investing In Women Leaders',
        description: 'Carolina explains how our zero-interest microloans work: paperwork verified by church or village leaders, immediate in-kind purchases within 24 hours, and 50% repayment beginning two months later so women can grow with dignity.',
        delay: '0.1s'
      },
      {
        videoSrc: '/videos/josh.mp4', // Josue Manishimwe field story
        label: 'Josue Manishimwe',
        title: 'Safari Chicken: Profit Engine Of Our Ecosystem',
        description: 'Josue walks through our chicken farm where profits fuel microloans, sanitation, nutrition, and nothing goes to waste—manure becomes fertilizer, and by May 2026 we will scale to 7,000 chickens with automated feeders, stronger biosecurity, and faster distribution.',
        delay: '0.3s'
      },
      {
        videoSrc: '/videos/emmanuel.mp4', // Emmanuel innovation story
        label: 'Emmanuel',
        title: 'Textile Hub: Profit With People First',
        description: 'Emmanuel explains how our Textile Hub reinvests every sale into wages, healthcare, training, and microloans—women master tailoring, digital printing, and cost management so the business grows without chasing profit.',
        delay: '0.5s'
      }
    ])

    onMounted(() => {
      // Initialize carousels and other jQuery plugins will be handled in main.ts
    })

    return {
      workProjects
    }
  }
})
</script>
